<template>
  <div class="section-main__warp fireMonitor">
    <div class="section-mian_left left">
      <div class="left_title">设备分类</div>
      <div class="left_tab">
        <div
          v-for="item in tabs"
          :key="item.value"
          :class="['tab', checkType.value == item.value ? 'active' : '']"
          @click="handleChange(item)"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="left_list">
        <el-scrollbar style="height: 100%">
          <div
            v-for="(item, index) in deviceList"
            :key="item.value"
            @click="handleClickList(item)"
            class="left_list-item"
            :class="checkInfo.value == item.value ? 'active' : ''"
          >
            <div class="tip" v-if="checkType.value == 2">
              {{ index + 1 }}
            </div>
            <div class="icon" v-else>
              <img
                v-if="item.value == 28"
                src="@/common/assets/images/device28.png"
                class="no-data_img"
              />
              <img
                v-if="item.value == 29"
                src="@/common/assets/images/device29.png"
                class="no-data_img"
              />
              <img
                v-if="item.value == 36"
                src="@/common/assets/images/device36.png"
                class="no-data_img"
              />
              <img
                v-if="item.value == 37"
                src="@/common/assets/images/device37.png"
                class="no-data_img"
              />
            </div>
            <div
              class="label"
              :class="
                checkType.value == 1 && checkInfo.value == item.value ? 'ellipsis' : ''
              "
            >
              {{ item.label }}
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div class="section-mian_right right">
      <fireMonitorDevice :deviceInfo="deviceInfo" :key="key" />
    </div>
  </div>
</template>

<script>
import { api } from "../api";
import fireMonitorDevice from "../components/fireMonitorDevice";
export default {
  components: {
    fireMonitorDevice,
  },
  data() {
    return {
      key: 0,
      checkType: {
        value: 1,
      },
      tabs: [
        {
          label: "系统设备",
          value: "1",
        },
        {
          label: "消控室设备",
          value: "2",
        },
      ],
      checkInfo: {},
      deviceTypeList: [
        // {
        //   label: "消防主机控制器",
        //   value: "27",
        //   deviceType: "27",
        //   icon: "iconfont-lunan icon-lunan-lujing4",
        // },
        {
          label: "自动喷淋和消防栓灭火系统",
          value: "28",
          deviceType: "28",
        },
        {
          label: "防烟排烟系统",
          value: "29",
          deviceType: "29",
          // url: require("@src/common/assets/images/homeMenu/device29.png"),
        },
        // {
        //   label: "电气火灾",
        //   value: "32",
        //   deviceType: "32",
        //   icon: "iconfont-lunan icon-lunan-lujing4",
        // },
        // {
        //   label: "可燃气体控制器",
        //   value: "33",
        //   deviceType: "33",
        //   icon: "iconfont-lunan icon-lunan-lujing4",
        // },
        // {
        //   label: "可燃气体探测点",
        //   value: "34",
        //   deviceType: "34",
        //   icon: "iconfont-lunan icon-lunan-lujing4",
        // },
        // {
        //   label: "消防电源",
        //   value: "35",
        //   deviceType: "35",
        //   icon: "iconfont-lunan icon-lunan-lujing4",
        // },
        {
          label: "消防水池",
          value: "36",
          deviceType: "36",
          // icon: "iconfont-lunan icon-lunan-lujing4",
        },
        {
          label: "高位水箱",
          value: "37",
          deviceType: "37",
          // icon: "iconfont-lunan icon-lunan-lujing4",
        },
      ],
      buildList: [],
      deviceList: [],
      deviceInfo: {},
      setTime: "",
    };
  },
  created() {},
  mounted() {
    this.deviceList = this.deviceTypeList;
    this.handleClickList(this.deviceList[0]);
  },
  beforeDestroy() {
    clearTimeout(this.setTime);
  },
  methods: {
    getBuildList() {
      this.$fetch(api.cms.queryBuilding, {
        buildingType: 1,
        pageFlag: false,
      }).then((response) => {
        if (response.success) {
          this.buildList = response.returnObj.map((item) => {
            return {
              label: item.buildingName,
              value: item.buildingCode,
              buildingCode: item.buildingCode,
            };
          });
          this.deviceList = [...this.buildList];
          this.handleClickList(this.deviceList[0]);
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleChange(item) {
      this.checkType = { ...item };
      if (item.value == 2) {
        this.getBuildList();
      }
      this.deviceList = item.value == 2 ? this.buildList : this.deviceTypeList;
    },
    handleClickList(item) {
      this.checkInfo = { ...item };
      if (this.setTime) {
        clearTimeout(this.setTime);
        this.setTime = setTimeout(() => {
          this.handleClickList(this.checkInfo);
        }, 60 * 1000);
      } else {
        this.setTime = setTimeout(() => {
          this.handleClickList(this.checkInfo);
        }, 60 * 1000);
      }
      this.$fetch(api.control.queryFirefightingDeviceList, {
        buildingCode: item.buildingCode,
        deviceMark: item.deviceType,
      }).then((res) => {
        if (res.success) {
          this.deviceInfo = res.returnObj;
          this.key++;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.fireMonitor {
  .left {
    &_title {
      border-left: 4px solid #407aee;
      padding-left: 8px;
      margin: 22px;
    }

    &_tab {
      display: flex;
      margin: 0 16px 0px 16px;

      .tab {
        flex: 1;
        // color: #9aa6c1;
        text-align: center;
        padding-bottom: 10px;
        border-bottom: 1px solid;
        @include set_theme_color(border-color, border-color);

        &:hover {
          // color: #fff;
          cursor: pointer;
        }
      }

      .active {
        // color: #fff;
        border-color: #407aee;
      }
    }

    &_list {
      margin: 16px;
      height: calc(100% - 110px);

      &-item {
        display: flex;
        padding: 0 9px;
        height: 45px;
        align-items: center;
        // color: #9aa6c1;
        @include set_theme_color(background-color,page-default-bg);
        border-bottom: 1px solid;
        @include set_theme_color(border-color, border-color);
        cursor: pointer;

        &.active {
          // background: #0d121c;
        }

        &:hover {
          // background: #0d121c;
        }

        .tip {
          width: 26px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          border-radius: 50%;
          // color: #fff;
          border: 1px solid #9aa6c1;
          margin-right: 10px;
          //   padding: 6px;
        }

        .label {
          width: 90%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .ellipsis {
          width: 75% !important;
        }

        .icon {
          width: 26px;
          height: 26px;
          line-height: 26px;
          font-size: 20px;
          text-align: center;
          margin-right: 10px;
        }

        .btn {
          position: absolute;
          right: 0;
          display: block;
          width: 50px;

          .el-icon-circle-plus-outline {
            font-size: 16px;
          }

          .el-button {
            color: #fff !important;
          }
        }
      }
    }
  }
}
</style>
